import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Wrapper, CloseIconWrapper, CloseIcon, IconUser, TitleWrapper, Title } from './styled';

const Header = ({ onClose }) => {
  const intl = useIntl();

  return (
    <Wrapper>
      <TitleWrapper>
        <IconUser />
        <Title>{ intl.formatMessage({ id: 'credentials.detail.title' }) }</Title>
      </TitleWrapper>
      <CloseIconWrapper onClick={ onClose }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Header;
